import { logoutUser, User } from "utils/user";

const connectTR = (
  oldWsClient: Object,
  user: User,
  timeOutId: number,
  typeLs: string,
  timeOutDisconnect: Function,
  connectSocket: Function,
  logoutUser: Function
) => {
  const wsClient = oldWsClient;
  wsClient["onerror"] = function wsError() {
    connectSocket();
  };
  wsClient["onopen"] = function wsOnopen() {
    wsClient["send"](
      JSON.stringify({
        request: "identify",
        token: user ? user.access_token : "",
      })
    );
  };
  wsClient["onmessage"] = function wsMessage(e) {
    if (typeof e.data !== "string") return;
    const socketData = JSON.parse(e.data);
    switch (socketData.type) {
      case "Login":
        logoutUser();
        break;
      case "Error":
        connectSocket();
        break;
      case "Ping":
        clearTimeout(timeOutId);
        timeOutDisconnect(typeLs);
        wsClient["send"](
          JSON.stringify({
            request: "pong",
            token: user ? user.access_token : "",
          })
        );

        break;

      default:
        break;
    }
  };

  return wsClient;
};

export default connectTR;
